import { render } from "./ServiceSelection.vue?vue&type=template&id=edc109ea"
import script from "./ServiceSelection.vue?vue&type=script&lang=js"
export * from "./ServiceSelection.vue?vue&type=script&lang=js"

import "./ServiceSelection.vue?vue&type=style&index=0&id=edc109ea&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__